module.exports = function() {
  return new Worker(__webpack_public_path__ + "a77550df35ccbec0645a.worker.js");
};